import { pathMap } from '../index';

const setRadarSfmp = (callback: any, appId: number) => {
  if ((window as any)?.PORTAL_GLOBAL_RADAR && pathMap.has(appId)) {
    console.log('have path====================', (window as any)?.PORTAL_ROUTER_CHANGE_TIME);
    (window as any).PORTAL_GLOBAL_RADAR?.sfmp({
      currentRoutePath: pathMap.get(appId),
      extendInfo: {
        routerChangeTime: (window as any)?.PORTAL_ROUTER_CHANGE_TIME,
        timestamp: new Date().getTime(),
        appId,
      },
      timestamp: new Date().getTime(),
    });
  } else {
    console.log('no path====================');
    callback && callback(appId);
  }
};

const useFmp = (appId: number) => {
  const fmpReport = () => {
    console.log(`@bury fmp埋点上报`);
    setRadarSfmp((appId: number) => {
      if ((window as any)?.PORTAL_GLOBAL_RADAR) {
        // 自定义fmp上报
        (window as any).PORTAL_GLOBAL_RADAR.event({
          name: 'custom_fmp',
          src: window.location.href,
          event_type: 'custom__fmp__event',
          extra_info: {
            timestamp: new Date().getTime(),
            routerChangeTime: (window as any)?.PORTAL_ROUTER_CHANGE_TIME, // aFmp/sFmp需要
            navigationStart: window.performance.timing.navigationStart, // Fmp需要
            appId,
          },
        });

        // 只针对冷启动场景进行radar自有fmp上报
        if (!(window as any).GLOBAL_LINGO_STORE.FMP.HOT_START) {
          console.log(
            'custom fmp duration ===================',
            new Date().getTime() - window.performance.timing.navigationStart
          );
          console.log('radar fmp ===================');
          (window as any).PORTAL_GLOBAL_RADAR?.fmp();
        }
      }
    }, appId);
  };

  return { fmpReport };
};

export default useFmp;
